module.exports = new Promise(resolve => {
            const script = document.createElement('script');
            script.src = window.location.origin + '/mfe/support-center/remoteEntry.js';
            script.onload = () => { resolve(window['supportCenter']); };
            script.onerror = () => { resolve({ get: () => Promise.resolve(() => () => 'Module supportCenter unavailable'), init: () => {} }); };
            document.head.appendChild(script);
        });